import React from 'react';
import { HiOutlineX } from 'react-icons/hi';
import { Spinner } from 'react-bootstrap';
import backgroundImage from '../assets/images/suggesstionedit.jpg';

const STATUS_LABELS = {
  pending: 'Pending',
  solved: 'Solved',
  completed: 'Completed',
  resolved: 'Solved',
};

const formatStatusLabel = (status) => {
  if (!status) {
    return STATUS_LABELS.pending;
  }

  const key = typeof status === 'string' ? status.toLowerCase() : 'pending';
  return STATUS_LABELS[key] ?? STATUS_LABELS.pending;
};

const formatDisplayDate = (value) => {
  if (!value) {
    return '—';
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '—';
  }

  return date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
};

const DetailRow = ({ label, value }) => (
  <div className="d-flex flex-column gap-1">
    <span className="text-uppercase text-muted small fw-semibold">{label}</span>
    <span className="fw-semibold text-dark">{value || '—'}</span>
  </div>
);

const ComplaintViewModal = ({
  complaint,
  open = false,
  loading = false,
  error = null,
  onClose,
}) => {
  if (!open) {
    return null;
  }

  const handleClose = () => {
    if (typeof onClose === 'function') {
      onClose();
    }
  };

  return (
    <div
      className="complaints-modal-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="complaint-view-title"
    >
      <div
        className="complaints-modal-panel lg"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      >
        <div className="complaints-modal-surface" aria-hidden="true" />
        <button
          type="button"
          onClick={handleClose}
          className="complaints-modal-close"
          aria-label="Close"
        >
          <HiOutlineX className="h-5 w-5" aria-hidden="true" />
        </button>

        <div className="complaints-modal-content">
          <div className="text-center">
            <h2 id="complaint-view-title" className="complaints-modal-title">
              Complaint Details
            </h2>
            <p className="complaints-modal-subtitle mt-2">
              Full view of the employee suggestion or complaint.
            </p>
          </div>

          {loading ? (
            <div className="py-5 text-center">
              <Spinner animation="border" role="status" />
            </div>
          ) : error ? (
            <div className="rounded-4 border border-danger-subtle bg-danger-subtle px-4 py-3 text-sm text-danger-emphasis">
              {error}
            </div>
          ) : (
            <div className="d-flex flex-column gap-4">
              <div className="row g-3">
                <div className="col-sm-6 col-lg-4">
                <DetailRow label="Employee" value={complaint?.name} />
                </div>
                <div className="col-sm-6 col-lg-4">
                <DetailRow label="Employee Code" value={complaint?.employeeCode} />
                </div>
                <div className="col-sm-6 col-lg-4">
                <DetailRow label="Mobile" value={complaint?.mobile} />
                </div>
                <div className="col-sm-6 col-lg-4">
                <DetailRow label="Status" value={formatStatusLabel(complaint?.status)} />
                </div>
                <div className="col-sm-6 col-lg-4">
                <DetailRow label="Created" value={formatDisplayDate(complaint?.createdAt || complaint?.date)} />
                </div>
                <div className="col-sm-6 col-lg-4">
                <DetailRow label="Resolved" value={formatDisplayDate(complaint?.resolvedAt)} />
                </div>
              </div>

              <div className="rounded-4 bg-white bg-opacity-75 p-4 shadow-sm">
                <div>
                  <p className="text-uppercase text-muted small fw-semibold">Subject</p>
                  <p className="mt-1 fw-semibold text-dark">
                    {complaint?.subject || '—'}
                  </p>
                </div>
                <div>
                  <p className="text-uppercase text-muted small fw-semibold">Message</p>
                  <p className="mt-1 small text-secondary" style={{ whiteSpace: 'pre-line' }}>
                    {complaint?.message || '—'}
                  </p>
                </div>
                <div>
                  <p className="text-uppercase text-muted small fw-semibold">Resolution Note</p>
                  <p className="mt-1 small text-secondary" style={{ whiteSpace: 'pre-line' }}>
                    {complaint?.resolutionNote || '—'}
                  </p>
                </div>
              </div>
            </div>
          )}

          <div className="d-flex justify-content-center">
            <button
              type="button"
              onClick={handleClose}
              className="btn complaints-modal-secondary px-4 py-2"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComplaintViewModal;
